import Container from "./styles";
import type { TypeListProps } from "./ListTypes";

/**
 * Styled-components implementation of List. Used by ListHybrid whenever a
 * consumer passes a styled-system prop or a styled() extension. This is the
 * unchanged legacy rendering path.
 */
const ListStyled = ({ as = "ul", children, ...rest }: TypeListProps) => {
  return (
    <Container as={as} {...rest}>
      {children}
    </Container>
  );
};

ListStyled.displayName = "List";

export default ListStyled;
